import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

function formatWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '-';
  }

  return warehouse.code ? `${warehouse.code} - ${warehouse.name}` : warehouse.name ?? '-';
}

export const warehouseLocationSideMsgBlocks = [
  {
    fields: [
      { label: '代號', value: 'code' },
      { label: '名稱', value: 'name' },
      { label: '倉別', value: (row) => formatWarehouseLabel(row?.warehouse) },
      { label: '狀態', value: entityStatusSideMsgValue },
      { label: '備註', value: 'remark' },
    ],
  },
];
